<template>
  <div style="width: 100%; " :style="!isUserThalesAdmin() ? 'margin-top:50px;': '' ">
    <h1 @click="getDataAsync">Tableau de pilotage</h1> 
    <div v-if="dateToday.getDay() != 0 && dateToday.getDay() != 6">
      <div class="data-slot-container"> 
        <div v-if="isLoadingTodaydayStat">
          <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
          Chargement...
        </div>
        <h4 style="min-width: 10rem;">Aujourd'hui </h4>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre de matériel entré" :value="today.nbCreated"/>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre de matériel sorti" :value="today.nbEnded"/>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre de matériel en bac rouge" :value="today.nbBacRouge"/>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre total de matériel dans le flux" :value="today.nbTotal"/>
        </div>
    </div>
    <div v-if="dateToday.getDay() == 0 || dateToday.getDay() == 6">
      <div class="data-slot-container"> 
        <h2>Données non disponible pour ce jour <span v-if="dateToday.getDay() == 6">(Samedi)</span><span v-if="dateToday.getDay() == 0">(Dimanche)</span></h2>
      </div>
    </div>
    <div v-if="dateToday.getDay() != 0">
      <div class="data-slot-container">
        <div v-if="isLoadingTodaydayStat">
          <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
          Chargement...
        </div>
        <h4 v-if="dateToday.getDay() != 1" style="min-width: 10rem;">Hier </h4>
        <h4 v-if="dateToday.getDay() == 1" style="min-width: 10rem;"> Vendredi</h4>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre de matériel entré" :value="yesterday.nbCreated"/>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre de matériel sorti" :value="yesterday.nbEnded"/>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre de matériel en bac rouge " :value="yesterday.nbBacRouge"/>
        <DocumentStatCard v-if="!isLoadingTodaydayStat" text="Nombre total de matériel dans le flux" :value="yesterday.nbTotal"/>
      </div>
    </div>
    <div v-if="dateToday.getDay() == 0 || dateToday.getDay() == 6">
      <div class="data-slot-container"> 
        <h2>Données non disponible pour ce jour (Samedi et Dimanche)</h2>
      </div>
    </div>
    <div class="data-slot-container" style="flex-direction: column;">
      <DocumentStatGraph
        title="Suivi encours Flux Sortants "
        :data="countAverageSerie.series"
        :isLoading="isLoadingCountAvgStat"
        :isUpdating="countAverageSerie.updating"
        :colors="['#30a9e6', '#4bc9b9', '#4b5ec9']"
        :updateData="getAvgScansStats"
      />
    </div>
    <div class="data-slot-container" style="flex-direction: column;">
      <DocumentStatGraph
        title="Suivi Lead-Time Flux Sortants"
        :data="leadTimeSerie.series"
        :isLoading="isLoadingLeadTimeStat"
        :isUpdating="leadTimeSerie.updating"
        :colors="['#3d71bf', '#4bc9b9', '#a04bd1']"
        :updateData="getAvgLeadTimeStats"
        :formatter="(v) => convertToDay(v)"
      />
    </div>
    <div class="data-slot-container" style="flex-direction: column;">
      <DocumentStatGraph
        title="Nombre d'entrées dans le bac rouge"
        :data="redBinSerie.series"
        :isLoading="isLoadingRebBinStat"
        :isUpdating="redBinSerie.updating"
        :colors="['#f09337']"
        :updateData="getRedBinStats"
        :formatter="(v) => v.toFixed()"
      />
    </div>
    <div class="data-slot-container" style="flex-direction: column;">
      <div style="margin-left: auto; margin-right: 5rem;">
        <b-dropdown
          split
          split-variant="outline-secondary"
          :text="chosenLoop.name"
          class="m-2"
        >
          <b-dropdown-item
            v-for="(loop, index) in loopList" :key="index"
            @click="updateLoopChoice(loop, index)"
          >
            {{loop}}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <LeadTimeGraph
        :title="` Nuage de points – Lead Time ${chosenLoop.name}`"
        :data="[scatterLeadTimeSerie.series[chosenLoop.index]]"
        :isUpdating="scatterLeadTimeSerie.updating"
        :isLoading="isLoadingScatterStat"
        :updateData="getLeadTimeScatter"
        :colors="['#3276a7']"
        :formatter="(v) => convertToDay(v)"
      />
    </div>
  </div>
</template>
<script>
import DocumentStatCard from './DocumentsStatCard'
import DocumentStatGraph from '../graph/BoardDocumentStatGraph'
import LeadTimeGraph from '../graph/LeadTimeGraph'
import server from '../../api/server.vue'

export default {
  name: 'BoardDocument',
  data() {
    return {
      dateToday: new Date(),
      isLoadingYesterdayStat: true,
      isLoadingTodaydayStat: true,
      isLoadingLeadTimeStat: true,
      isLoadingCountAvgStat: true,
      isLoadingRebBinStat: true,
      isLoadingScatterStat: true,
      today: {
        nbCreated: 0,
        nbEnded: 0,
        nbBacRouge: 0,
        nbTotal: 0,
      },
      yesterday: {
        nbCreated: 0,
        nbEnded: 0,
        nbBacRouge: 0,
        nbTotal: 0,
      },
      chosenLoop: {name: 'France', index: 0},
      loopList : ['France', 'Union européenne', ' Grand export'],
      countAverageSerie: {
        updating: false,
        series: [
          { name: 'France', data: [] },
          { name: 'Union européenne', data: [] },
          { name: 'Grand export', data: [] },
        ]
      },
      leadTimeSerie: {
        updating: false,
        series: [
          { name: 'France', data: [] },
          { name: 'Union européenne', data: [] },
          { name: 'Grand export', data: [] },
        ]
      },
      scatterLeadTimeSerie: {
        updating: false,
        series: [
          { name: 'France', data: [], references: [], leadTimeMean: 0 },
          { name: 'Union européenne', data: [], references: [], leadTimeMean: 0 },
          { name: 'Grand export', data: [], references: [], leadTimeMean: 0 },
        ]
      },
      redBinSerie: {
        updating: false,
        series: [
          { name: 'Nombre de mise en bac rouge', data: [] }
        ]
      }
    }
  },
  methods: {
    getDataAsync() {
      this.countAverageSerie.series.forEach(s => s.data = [])
      this.leadTimeSerie.series.forEach(s => s.data = [])
      this.redBinSerie.series.forEach(s => s.data = [])
      const promises = [
        this.getYesterdayStats(),
        this.getTodayStats(),
        this.getAvgScansStats(),
        this.getAvgLeadTimeStats(),
        this.getLeadTimeScatter(),
        this.getRedBinStats(),
      ];
      Promise.all(promises).then(() => {
      }).catch((e) => {
        console.error(e)
        this.$toasted.error('Erreur de récupération des données')
      })
    },
    getYesterdayStats() {
      this.isLoadingYesterdayStat = true
      return server.getYesterdayScansStats().then(response => {
          const data = response.data
          this.yesterday.nbCreated = data.nb_created
          this.yesterday.nbEnded = data.nb_ended
          this.yesterday.nbBacRouge = data.nb_red_bin
          this.yesterday.nbTotal = data.nb_total
          this.isLoadingYesterdayStat = false
      })
    },
    getTodayStats() {
      this.isLoadingTodaydayStat = true
      return server.getTodayScansStats().then(response => {
          const data = response.data
          this.today.nbCreated = data.nb_created
          this.today.nbEnded = data.nb_ended
          this.today.nbBacRouge = data.nb_red_bin
          this.today.nbTotal = data.nb_total
          this.isLoadingTodaydayStat = false
      })
    },
    getAvgScansStats(days = 30, offset = 0) {
      for (let i = 0; i <3; i++) {
        this.countAverageSerie.series[i].data = []
      }
      this.countAverageSerie.updating = true
      this.isLoadingCountAvgStat = true
      return server.getScansStats('graph_avg_scans', days, offset).then(response => {
        this.addToSeries(this.countAverageSerie.series, response.data)
        this.countAverageSerie.updating = false
        this.isLoadingCountAvgStat = false
      })
    },
    getAvgLeadTimeStats(days = 30, offset = 0) {
      for (let i = 0; i <3; i++) {
        this.leadTimeSerie.series[i].data = []
      }
      this.leadTimeSerie.updating = true
      this.isLoadingLeadTimeStat = true
      return server.getScansStats('graph_lead_time', days, offset).then(response => {
        this.addToSeries(this.leadTimeSerie.series, response.data)
        this.leadTimeSerie.updating = false
        this.isLoadingLeadTimeStat = false
      })
    },
    getLeadTimeScatter() {
      for (let i = 0; i <3; i++) {
        this.scatterLeadTimeSerie.series[i].data = []
      }
      const days = 30
      const offset = 0
      this.isLoadingScatterStat = true
      return server.getScansStats('graph_scatter_lead_time', days, offset).then(response => {
        this.addToScatterLeadTimeSeries(this.scatterLeadTimeSerie.series, response.data)
        this.computeLeadTimeMean(this.scatterLeadTimeSerie.series, response.data)
        this.scatterLeadTimeSerie.updating = false
        this.isLoadingScatterStat = false
      })
    },
    getRedBinStats(days = 30, offset = 0) {
      this.redBinSerie.series[0].data = []
      this.redBinSerie.updating = true
      this.isLoadingRebBinStat = true
      return server.getScansStats('graph_red_bin', days, offset).then(response => {
        const data = response.data
        const result = []
        for(const date in data){
          result.push([date, data[date]])
        }
        this.redBinSerie.series[0].data = [...result, ...this.redBinSerie.series[0].data]
        this.redBinSerie.updating = false
        this.isLoadingRebBinStat = false
      })
    },
    addToSeries(series, newdata) {
      const fr = []
      const eu = []
      const ge = []
      for(const d in newdata){
          fr.push([d, newdata[d]['france']])
          eu.push([d, newdata[d]['union_europeenne']])
          ge.push([d, newdata[d]['grand_export']])
      }
      series[0].data = [...fr, ...series[0].data]
      series[1].data = [...eu, ...series[1].data]
      series[2].data = [...ge, ...series[2].data]
    },
    addToScatterLeadTimeSeries(series, newdata) {
      const fr = []
      const eu = []
      const ge = []
      const fr_ref = []
      const eu_ref = []
      const ge_ref = []
  
      const loop_list = ['france', 'union_europeenne', 'grand_export']
      for(const d in newdata){
        for (const loop of loop_list){
          if (loop == 'france'){
            for (const el of newdata[d][loop]['lead_times']){
              fr.push([d, el['lead_time']])
              fr_ref.push([d, el['code']])
            }
          }
          else if (loop == 'union_europeenne'){
            for (const el of newdata[d][loop]['lead_times']){
              eu.push([d, el['lead_time']])
              eu_ref.push([d, el['code']])
            }
          }
          else if (loop == 'grand_export'){
            for (const el of newdata[d][loop]['lead_times']){
              ge.push([d, el['lead_time']])
              ge_ref.push([d, el['code']])
            }
          }
        }
      }
      series[0].data = [...fr, ...series[0].data]
      series[1].data = [...eu, ...series[1].data]
      series[2].data = [...ge, ...series[2].data]

      series[0].references = [...fr_ref, ...series[0].references]
      series[1].references = [...eu_ref, ...series[1].references]
      series[2].references = [...ge_ref, ...series[2].references]
    },
    convertToDay(number) {
      var hours = Math.floor(number)
      var days = (hours/24).toFixed(1)
      return days
    },
    updateLoopChoice (loop, index) {
      this.chosenLoop.name = loop
      this.chosenLoop.index = index
    },
    computeLeadTimeMean(series, newdata) {
      const fr_lt = []
      const eu_lt = []
      const ge_lt = []

      const loop_list = ['france', 'union_europeenne', 'grand_export']
      for(const d in newdata){
        for (const loop of loop_list){
          if (loop == 'france'){
            fr_lt.push(newdata[d][loop]['mean_lead_time'])
          }
          else if (loop == 'union_europeenne'){
            eu_lt.push(newdata[d][loop]['mean_lead_time'])
          }
          else if (loop == 'grand_export'){
            ge_lt.push(newdata[d][loop]['mean_lead_time'])
          }
        }
      }
      let frLeadtimes = 0
      for (const lt of fr_lt) {
        frLeadtimes += lt
      }
      let frLeadtimeMean = (frLeadtimes / fr_lt.length)
      series[0].leadTimeMean = this.convertToDay(frLeadtimeMean)

      let euLeadtimes = 0
      for (const lt of eu_lt) {
        euLeadtimes += lt
      }
      let euLeadtimeMean = (euLeadtimes / eu_lt.length)
      series[1].leadTimeMean = this.convertToDay(euLeadtimeMean)

      let geLeadtimes = 0
      for (const lt of ge_lt) {
        geLeadtimes += lt
      }
      let geLeadtimeMean = (geLeadtimes / ge_lt.length)
      series[2].leadTimeMean = this.convertToDay(geLeadtimeMean)
    },
  },
  mounted: function () {
    this.getDataAsync()
  },
  components: {
    DocumentStatCard,
    DocumentStatGraph,
    LeadTimeGraph,
  }
}
</script>

<style type="css" scoped>
.data-slot-container {
  margin-top: 2rem;
  width: 100%;
  padding: 0.5rem;
  border-radius: 10px;

  font-family: 'Montserrat';
  color: #242424;
  background-color: var(--a-dark-grey);

  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

.data-slot-header {
  position: relative;
  padding: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.data-slot-header > span {
  position: absolute;
  left: 0.5em;
  top: 0.5em;
}

</style>



// WEBPACK FOOTER //
// src/components/document/BoardDocument.vue